export default __webpack_public_path__ + "static/media/IMG_4468.3b65ef98.jpg";